function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1904(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 58.19,
    height: 43.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.38375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 21.535,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.07,
    width: 58.19,
    height: 43.07,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.152857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 64.605,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.13,
    width: 58.19,
    height: 60.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.312857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 116.44999999999999,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146.77,
    width: 58.19,
    height: 67.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.698333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 180.73000000000002,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214.69,
    width: 58.19,
    height: 69.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.5475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 249.51,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 284.33,
    width: 58.19,
    height: 72.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 320.65,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.96,
    width: 58.19,
    height: 75.64,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.312857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 394.78,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 432.6,
    width: 58.19,
    height: 85.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.312857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 475.13,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 517.66,
    width: 58.19,
    height: 89.35,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.698333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 562.3349999999999,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607.01,
    width: 58.19,
    height: 92.99,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4655555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.095,
    y: 653.505,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 0,
    width: 72.02,
    height: 81.88,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.003333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.19999999999999,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.21,
    y: 0,
    width: 73.85,
    height: 81.88,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.23125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.135,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.06,
    y: 0,
    width: 75.07,
    height: 81.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.02333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.595,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.13,
    y: 0,
    width: 76.13,
    height: 81.88,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.688333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.195,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.26,
    y: 0,
    width: 81.62,
    height: 81.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 396.07,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.88,
    y: 0,
    width: 83.6,
    height: 81.88,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.187999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.68,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.48,
    y: 0,
    width: 86.79,
    height: 81.88,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.375999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.875,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.27,
    y: 0,
    width: 92.73,
    height: 81.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.097777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.635,
    y: 40.94,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 81.88,
    width: 97.97,
    height: 78.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.175,
    y: 120.94999999999999,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 160.02,
    width: 97.97,
    height: 80.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.05375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.175,
    y: 200.235,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 240.45,
    width: 97.97,
    height: 86.28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.175,
    y: 283.59,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 326.73,
    width: 97.97,
    height: 90.48,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.925714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.175,
    y: 371.97,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 417.22,
    width: 97.97,
    height: 92.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.175,
    y: 463.545,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 509.87,
    width: 97.97,
    height: 94.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.175,
    y: 556.895,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.19,
    y: 603.92,
    width: 97.97,
    height: 96.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.013333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.175,
    y: 651.9599999999999,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.15,
    y: 81.88,
    width: 105.07,
    height: 89.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.950000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.685,
    y: 126.72999999999999,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.23,
    y: 81.88,
    width: 107.02,
    height: 89.7,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.74,
    y: 126.72999999999999,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.24,
    y: 81.88,
    width: 107.85,
    height: 89.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.165,
    y: 126.72999999999999,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.1,
    y: 81.88,
    width: 110.91,
    height: 89.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.2125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.5550000000001,
    y: 126.72999999999999,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.01,
    y: 81.88,
    width: 112.99,
    height: 89.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.950000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.505,
    y: 126.72999999999999,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.15,
    y: 171.58,
    width: 114.97,
    height: 92.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.244285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.635,
    y: 217.935,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.15,
    y: 264.3,
    width: 114.97,
    height: 105.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.675555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.635,
    y: 316.84000000000003,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.15,
    y: 369.37,
    width: 114.97,
    height: 107.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.3925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.635,
    y: 422.94,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.15,
    y: 476.51,
    width: 114.97,
    height: 109.63,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.661428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.635,
    y: 531.325,
    fontFamily: "Arial"
  }, "\n        De_Soto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.15,
    y: 586.14,
    width: 114.97,
    height: 113.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.265714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.635,
    y: 643.0699999999999,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.13,
    y: 171.58,
    width: 97.36,
    height: 136.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.81,
    y: 239.895,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.49,
    y: 171.58,
    width: 101.38,
    height: 136.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.896666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.18,
    y: 239.895,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.87,
    y: 171.58,
    width: 113.79,
    height: 136.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.765,
    y: 239.895,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.66,
    y: 171.58,
    width: 116.34,
    height: 136.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.8299999999999,
    y: 239.895,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.13,
    y: 308.22,
    width: 162.42,
    height: 111.46,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.576666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.34,
    y: 363.95000000000005,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.13,
    y: 419.67,
    width: 162.42,
    height: 132.72,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.34,
    y: 486.03000000000003,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.13,
    y: 552.39,
    width: 162.42,
    height: 147.61,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.087142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.34,
    y: 626.1949999999999,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.55,
    y: 308.22,
    width: 110.16,
    height: 244.34,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.63,
    y: 430.39000000000004,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.71,
    y: 308.22,
    width: 156.29,
    height: 244.34,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.855,
    y: 430.39000000000004,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.55,
    y: 552.56,
    width: 266.45,
    height: 147.44,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.286666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.775,
    y: 626.28,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1904);
export default __webpack_public_path__ + "static/media/1904.f17d5581acf0f7b1e64b5f699ad2a040.svg";
export { ForwardRef as ReactComponent };